export default __webpack_public_path__ + "assets/images/c7ded1f2a55c66ce61165e985ecf66b2.svg";